import { useTranslation } from 'react-i18next';

export default function FocusSelector({ 
  applicableFocus, 
  selectedFocusIds, 
  onFocusChange 
}) {
  const { t, i18n } = useTranslation();

  if (!applicableFocus || applicableFocus.length === 0) return null;

  return (
    <div className="mt-4 md:mt-6">
      <label className="block text-sm md:text-xl font-semibold text-gray-700 mb-2 md:mb-4">
        {t('training.focus')}
      </label>
      <div className="flex flex-wrap gap-3 md:gap-4">
        {applicableFocus.map((focusItem) => (
          <label
            key={focusItem.id}
            className="flex items-center gap-2 md:gap-2 cursor-pointer hover:bg-gray-50 px-2 md:px-3 py-1.5 md:py-2 rounded-lg transition-colors whitespace-nowrap"
          >
            <input
              type="checkbox"
              checked={selectedFocusIds.includes(focusItem.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  onFocusChange([...selectedFocusIds, focusItem.id]);
                } else {
                  onFocusChange(selectedFocusIds.filter(id => id !== focusItem.id));
                }
              }}
              className="h-4 w-4 md:h-5 md:w-5 accent-primary-500 cursor-pointer flex-shrink-0"
            />
            <span className="text-sm md:text-lg text-gray-700">
              {focusItem[`name${i18n.language === 'he' ? 'He' : 'En'}`]}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}

